import { styled } from '@/stitches.config';
import { keyframes } from '@stitches/react';

interface TimerProps {
  durationInSeconds: number;
  radius?: number;
  strokeWidth?: number;
}

const scaleUp = (offset: number) => {
  return keyframes({
    '0%': { strokeDashoffset: 0 },
    '100%': { strokeDashoffset: offset },
  });
};

export function Timer({
  radius = 16,
  strokeWidth = 4,
  durationInSeconds = 10,
}: TimerProps) {
  const normalizedRadius = radius - strokeWidth * 2;
  const circumference = normalizedRadius * 2 * Math.PI;

  const strokeDashoffset = circumference - (0 / 100) * circumference;

  return (
    <svg
      height={radius * 2}
      width={radius * 2}
      style={{
        overflow: ' auto',
      }}
    >
      <Circle
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference + ' ' + circumference}
        css={{
          animation: `${scaleUp(
            strokeDashoffset
          )} ${durationInSeconds}s forwards`,
          animationTimingFunction: 'linear',
          transform: 'rotate(-90deg) scaleY(-1)',
          transformOrigin: 'center',
          stroke: 'currentColor',
          willChange: 'stroke-dashoffset',
        }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
}

const Circle = styled('circle');
